export default {
  headerContent: {
    title: 'Bereket Sigorta İş Yeri Sigortası Hesaplama',
    slogan: "İş Yeri Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'İŞ YERİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Bereket Sigorta İş Yeri Sigortası',
    description: {
      title: 'Bereket Sigorta İş Yeri (Paket) Sigortası Nedir? ',
      content: [
        'Bereket Sigorta iş yeri sigortası, işletmenizi oluşabilecek risklere karşı güvence altına alan geniş kapsamlı sigorta planıdır.',
        'İş yeri sigortası ile işletmenizi yangın, hırsızlık, deprem gibi birçok riske karşı güvence altına alarak büyük çaplı maddi kayıpları önleyebilirsiniz.'
      ]
    },
    subContent: {
      title: 'Bereket Sigorta İşyeri (Paket) Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph: 'İş yeri sigortası teminatları 2 ye ayrılmaktadır.',
          subList: null
        },
        {
          paragraph: '<strong><em><u>Bu teminatlar;</u></em></strong>',
          subList: [
            'Yangın, yıldırım, infilak',
            'Dahili su',
            'Kar ağırlığı',
            'Duman',
            'Kara taşıtları çarpması',
            'Hava taşıtları çarpması',
            'Deniz taşıtları çarpması',
            'Sel-su baskını',
            'Fırtına',
            'Enkaz kaldırma',
            'Glkhhknh ve terör',
            'Yangın mali mesuliyet',
            'İş durması',
            'Deprem',
            'Hırsızlık',
            'Cam kırılması teminatını içermektedir.'
          ]
        },
        {
          paragraph:
            '<strong><em><u>İsteğe bağlı teminatlar;</u></em></strong>',
          subList: [
            'Deprem',
            'Elektronik cihaz',
            'Emniyet suistimal',
            'Ferdi kaza',
            'İşveren mali sorumluluk',
            'Kar kaybı',
            'Makine kırılması',
            'Makine kırılmasına bağlı kar kaybı',
            'Taşınan para',
            'Tedavi masrafları',
            'Üçüncü şahıs mali sorumluluk teminatını kapsar.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'İş Yeri Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'İş Yeri Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'İş Yeri Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Bereket Sigorta İş Yeri Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title:
        'Bereket Sigorta İşyeri (Paket) Sigortası Asistans Hizmetleri Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'İş yeri bilgi hattı',
            'Su tesisatı hizmeti',
            'Elektrik tesisatı hizmeti',
            'Çilingir hizmeti',
            'Tıbbi bilgi ve danışma',
            'Tıbbi nakil (kara ambulansı)',
            'Turistik, kültürel ve sosyal aktivitelerle ilgili rezervasyon',
            'Bilet alımı/ulaştırma',
            'Otel rezervasyonları',
            'Restaurant rezervasyonu',
            'Kiralık araç rezervasyonları',
            'Uçak bileti alma / ulaştırma',
            'Seyahat organizasyon hizmetleri',
            'Hediye, çiçek vb. Gönderimler',
            'İş yeri ihtiyaçlarına yönelik organizasyonlar',
            'Kurye ve kargo hizmetleri',
            'Vize ve konsolosluk bilgilendirme hattı',
            'Araç bilgi hattı',
            'Araç muayene hizmeti (organizasyon)',
            'Kongre ve fuar bilgi hattı',
            'Eğitim danışmanlığı',
            'İş yeri onarım hizmetleri',
            'Pc yardım hizmetleri',
            'Santral ve mesaj servisi'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph:
            'İş yeri sigortası yaptırılması zorunlu bir sigorta değildir. İşletme sahipleri kendi isteklerine göre iş yeri paket sigortası yaptırabilmektedirler.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İş Yeri Sigortasında Emtea Nedir?',
      content: [
        {
          paragraph:
            'Emtea iş yerinizin içerisinde satılmak üzere bulundurduğunuz eşya veya mallara verilen genel bir isimdir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'İş yeri sigortası kapsamı poliçenize ekletmiş olduğunuz teminatlarla orantılıdır.',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortası genel olarak işletmenizin uğrayacağı maddi zararları güvence altına almaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Teminat Dışı Durumlar Neler?',
      content: [
        {
          paragraph:
            'Teminat dışı kalan haller TSB tarafından yayınlanan genel şartlarda yer alan durumlara ek olarak poliçe teminatları arasında yer almayan teminatlardır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Ne Zaman Başlar?',
      content: [
        {
          paragraph:
            'İş yeri sigortasının doğru düzenlene bilmesi için kesin olan bilgilere gerek vardır.',
          subList: null
        },
        {
          paragraph: 'İstenen belgeler;',
          subList: [
            'İşletme tüzel kişilik ise işletmenin vergi numarası,',
            'İşletme şahıs şirketi ise işyeri sahibi TC’si,',
            'İş yeri içerisinde bulunan emtea bedelleri,',
            'Dekorasyon ve demirbaş bedelleri,',
            'İş yerinde bulunan cam bedelleri,',
            'İş yeri yangın güvenlik önlemleri,',
            'İş yeri hırsızlık güvenlik önlemleri bilgileri istenmektedir.'
          ]
        }
      ]
    },
    {
      title:
        'Bereket Sigorta İşyeri Sigortası Alırken Dikkat Edilmesi Gerekenler Nelerdir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası işletme sektörüne göre ve işletmeye özel olarak düzenlenmektedir.',
          subList: [
            'İşletme unvanının doğruluğu kontrol edilmelidir.',
            'İş yeri sigortası teminatları kontrol edilmeli ve teminat limitleri yeterlimi değerlendirilmelidir.',
            'İş yeri sigortası içeriğinde yazan emtea, demirbaş, dekorasyon ve cam bedelleri kontrol edilmelidir.'
          ]
        }
      ]
    },
    {
      title:
        'Bereket Sigorta İşyeri Paket Sigortası Teminat Bedelleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası teminat bedelleri işletmenin faaliyet gösterdiği sektör, işletme büyüklüğü, işletme içerisinde bulunan dekorasyon ve emtea gibi birçok etken göz önüne alınarak belirlenmektedir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Kimler İşyeri Sigortası Yaptırmalıdır?',
      content: [
        {
          paragraph:
            'İş yeri sigortası isteğe bağlı olarak yaptırılan ve her hangi bir kurum, kişi sektör kısıtlaması bulunmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Paket Sigortası Avantajlı Mı?',
      content: [
        {
          paragraph:
            'İş yeri sigortası işletmenizi, çalışanlarınızı ve sizi karşılaşabileceğiniz riskeler karşısında koruma altına alarak büyük çaplı maddi kayıpları önlemektedir. ',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortası işletmenizi hırsızlık, yangın, sel ve su baskınlarına karşı güvence altına alarak sermayenizi güvence altına almaktadır. Bu sebeple işletmenizi risklere karşı güvence altında tutmak hem çalışanlarınız için hem de sermayeniz için son derece önemlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Deprem Teminatı Nedir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası deprem teminatı işletmenizde deprem riskinin gerçekleşmesi sonucunda oluşacak hasarlara karşı koruma sağlamaktadır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Cam Kırılması Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Bereket Sigortası işyeri sigortası teminatları arasında yer alan cam kırılması teminatı iş yerinizde bulunan camların kazaen veya poliçede belirtilen sebeplerden dolayı kırılması riskine karşılık güvence sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Hangi Riskleri Kapsamaz?',
      content: [
        {
          paragraph:
            'İş yeri sigortası TSB’nin belirtmiş olduğu riskleri ve teminat altına alınmamış riskleri kapsamaz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta İşyeri Adresi Değişirse İşyeri Sigortası Ne Olur?',
      content: [
        {
          paragraph:
            'İş yeri adres değişikliği oluşması durumunda adres değişikliği zeyli talep edebilirsiniz. Adres değişikliğinizi acentenize bildirerek zeyil düzenlenmesini isteyebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Su Baskınını Karşılar Mı?',
      content: [
        {
          paragraph:
            'İş yeri sigortası içerisinde sel ve su baskınları teminatı bulunması durumunda oluşan hasar poliçe limitleri kapsamında karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortasında Metrekare Önemli Mi?',
      content: [
        {
          paragraph:
            'İş yeri sigortası yapılırken eğer bina dahil edilecekse metrekare önemlidir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortasında Çilingir Hizmeti Var Mı?',
      content: [
        {
          paragraph:
            'Bereket Sigorta çilingir hizmetini asistans paketi içeriğinde müşterilerine ücretsiz olarak sunmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket İş Yeri Sigortası Muhasebeleştirilir Mi?',
      content: [
        {
          paragraph: 'Bereket İş Yeri Sigortası Muhasebeleştirilir Mi?',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'İş yeri sigortanızı Alokasko aracılığıyla hızlı ve kolay bir şekilde yaptırmanız mümkündür.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com üzerinden dolduracağınız başvuru formu veya 7/24 ulaşabileceğiniz çağrı merkezi ile <strong>en uygun iş yeri sigortası teklifi</strong> alabilir, aldığınız teklifi değerlendirebilir ve poliçenizi kolayca satın alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Online İşyeri Sigortası Hesaplama Yapılır Mı?',
      content: [
        {
          paragraph:
            'İş yeri sigortası hesaplaması online olarak yapılabilmektedir. Yalnız bazı sektörler için risk analizi gerekmektedir. Bu sektörler risk oranı yüksek olan sektörlerdir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta İşyeri Sigortası Hesaplaması Yapılırken Nelere Dikkat Edilmelidir?',
      content: [
        {
          paragraph:
            'İş yeri sigorta her işletmeye özel olarak düzenlenmektedir. ',
          subList: [
            'Poliçede yazan işletme ünvanına ve işletme adresi,',
            'İşletmede yer alan emtea ve dekorasyon bedelleri,',
            'İşletmeniz bulunduğu sektör bilgisi,',
            'İşletmenin bulunduğu bina tarzı,',
            'İşletme içerisinde bulunan güvenlik önlemleri.'
          ]
        },
        {
          paragraph:
            'Yukarıda yazan maddeler poliçe düzenlenmeden önce kontrol edilmelidir. Bu bilgilerden birinin veya bir kaçının yanlış olması durumunda hasar anında zorluk yaşanmasına sebep olmaktadır. Bununla birlikte sigorta şirketi tarafından poliçe gereksiz sayılabilir. Bu nedenle verilen bilgilerin doğru ve kesin olması sağlamalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Kar Kaybını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Bereket Sigorta iş yeri sigortası kâr kaybını poliçede teminat altına alınmış bir riskin gerçekleşmesi sonucunda işin durması veya aksaması durumunda karşılamaktadır. Poliçede teminat altına alınamayan riskler sonucunda oluşacak kâr kayıpları karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'İş yeri sigorta işletmeler arasında farklılık göstermektedir. Bu farklılıklar kimi zaman sektörel kimi zaman ise büyüklüktür. İşletme sektörü ve işletme büyülüğü oluşabilecek risklerin büyüklüğünü etkilemektedir. Bu nedenle iş yeri sigortasında net bir fiyat yoktur.',
          subList: null
        },
        {
          paragraph:
            'Size özel hazırlanmış iş yeri sigortası fiyatlarını uzman danışmanlarımızdan talep edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Hesaplama Adımları Nelerdir?',
      content: [
        {
          paragraph: 'İş yeri sigortası hesaplaması 4 adımda yapılmaktadır.',
          subList: null
        },
        {
          paragraph:
            '<ol><li>Sigortalının T.C. Kimlik Numarası vehya vergi kimlik numarası sisteme girilir ve müşteri kaydı yapılır,</li> <li>Sigortalanacak işletmeniz açık adresi eklenir,</li><li>İşletmeye ait emtea ve dekorasyon bedelleri eklenir,</li><li>İstenen teminatlar seçilir ve fiyat hesaplaması yapılır.</li></ol>',
          subList: null
        },
        {
          paragraph:
            'Bu 4 adımın tamamlanması sonucunda iş yeri sigortanızın primini görüntüleyebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'İşyeri Sigortası Fiyat Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'İş yeri teklifinizi her ihtiyacınıza cevap verebilen internetten alabilmeniz mümkündür.',
          subList: null
        },
        {
          paragraph:
            'İnternet aracılığıyla iş yeri sigortası satın almak için online teklif ekranımızı kullanabilir veya başvuru formu doldurarak uzmanlarımızdan yardım alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortasını online alarak hem işletmenizi güvence altına alabilirsiniz hem de sağlamış olduğu fiyat avantajları ile bütçenizi koruyabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
